import React from 'react'
import HeroA from './components/HeroA'
import Location from './components/Location'
import Footer1 from "./components/Footer"
import EventSpecial from './components/EventSpecial'
import TextR from "./components/TextR";
import VideoT from "./components/Video";

import ScrollToTopButton from "./components/ScrollToTopButton";

import Cookies from "./components/cookie/cookie";

const Start = () => {
  return (
    <>
    <Cookies />
    <HeroA />
    <VideoT />
    <TextR />
    <EventSpecial />
    <Location />
    <Footer1 />
    <ScrollToTopButton />
    </>
  )
}

export default Start